import React, { useEffect, useState } from "react";
import { useContext } from "react";
import SimpleContext from "./../../context/SimpleContext";
import "./Factors.css";
import config from "./../../../services/config.json";
import { saveAs } from "file-saver";
import right from "../../img/right.png";
import { useHistory } from "react-router";
import Preloader from "../../Preloader/preloader";
import Preloader2 from "../../Preloader/preloader3";
import { browserName, browserVersion } from "react-device-detect";
import axios from "axios";
// import "../sefareshat.css"
const SafareshatDetailsApi = () => {
  const context = useContext(SimpleContext);
  const [pre, setpre] = useState(false);
  const [updata, setupdata] = useState(1);
  let [selectedId, setselectedId] = useState([]);
  const history = useHistory();

  // function ShowFactor() {
  //   setpre(true);
  //   let MyTime = Date.now();
  //   let TimeHeader = context.Encriptor(MyTime + context.timeMiliSecondDef);
  //   const myheaders = {
  //     "atu-token": TimeHeader,
  //   };
  //   async function getData() {
  //     const url = `${context.baseUrlApiPakhsh}${config.downloadFactorWebApp}`;
  //     const formData = new FormData();
  //     formData.append("factorID", context.orderDetailId);
  //     formData.append("type", "api");
  //     formData.append(
  //       "customerId",
  //       Object.values(context.UseInFo).length > 0 && context.UseInFo.customerId,
  //     );
  //     formData.append("appTypeId", context.AppType);
  //     formData.append("appVersion", browserName);
  //     formData.append("AndroidVersion", browserVersion);
  //     formData.append("deviceId", context.UniqueUUID);
  //     const param = {
  //       method: "post",
  //       body: formData,
  //       headers: myheaders,
  //     };
  //     const sendRequest = await fetch(url, param);
  //     const response = await sendRequest.json();
  //     return response;
  //   }
  //   try {
  //     getData().then((data) => {
  //       setpre(false);
  //       if (data.popUp !== null) {
  //         if (data.popUp.text === "" && data.popUp.imageLink === "") {
  //           window.open(data.popUp.link, "noopener,noreferrer");
  //         } else {
  //           context.setmodalPopUp(true);
  //           context.setTextPopUp(data.popUp);
  //         }
  //       } else {
  //         context.setmodalPopUp(false);
  //       }
  //       if (data.code === 200) {
  //         context.Handelerror("فاکتور شما با موفقیت دانلود شد");
  //         saveAs(data.response.url);
  //       } else {
  //         context.Handelerror(data.message);
  //       }
  //     });
  //   } catch (ex) {
  //     console.log(ex);
  //   }
  // }
const ShowFactor = async () => {
  setpre(true);

  try {
    const MyTime = Date.now();
    const TimeHeader = context.Encriptor(
      MyTime + context.timeMiliSecondDef
    );

    const formData = new FormData();

    formData.append("factorID", context.orderDetailId);
    // formData.append("type", "api");
    formData.append(
      "customerId",
      Object.values(context.UseInFo).length > 0
        ? context.UseInFo.customerId
        : ""
    );
    formData.append("appTypeId", context.AppType);
    formData.append("appVersion", browserName);
    formData.append("AndroidVersion", browserVersion);
    formData.append("deviceId", context.UniqueUUID);

    // مرحله اول: دریافت لینک دانلود
    const response = await axios.post(
      `${context.baseUrlApiPakhsh}${config.downloadFactorWebApp}`,
      formData,
      {
         responseType: "blob",
        headers: {
          "atu-token": TimeHeader,
        },
      }
    );

    const file = new Blob([response.data], {
      type: "application/pdf",
    });

    const fileURL = URL.createObjectURL(file);

    const link = document.createElement("a");
    link.href = fileURL;
    link.download = `factor-${context.orderDetailId}.pdf`;
    link.click();

    URL.revokeObjectURL(fileURL);

    context.Handelerror("فاکتور شما با موفقیت دانلود شد");
  } catch (err) {
    console.error(err);
    context.Handelerror("خطا در دانلود فاکتور");
  } finally {
    setpre(false);
  }
};
  const selectfactor = (id) => {
    let idd = selectedId.find((i) => i === id);

    if (idd !== undefined) {
      let data = selectedId.filter((i) => i !== id);
      setselectedId(data);
      setupdata(updata + 1);
    } else {
      selectedId.push(id);
      setselectedId(selectedId);
      setupdata(updata + 1);
    }
  };

  return (
    <>
      {context.showPrepage === true ? (
        <Preloader />
      ) : (
        updata > 0 && (
          <div
            style={{
              width: "100%",
              height: "92vh",
              marginTop: "8vh",
              backgroundColor: "#e5e5e5",
              marginBottom: "6vh",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                height: "8vh",
                position: "fixed",
                zIndex: "3",
                top: "0",
                backgroundColor: "#fff",
                borderBottom: "1px solid #e5e5e5",
              }}
            >
              <div
                style={{
                  width: "15%",
                  display: "flex",
                  justifyContent: "flex-start",
                  textAlign: "center",
                  alignItems: "center",
                }}
              >
                <img
                  onClick={() => history.go(-1)}
                  className="backIcon"
                  src={right}
                />
              </div>
              <div
                style={{
                  width: "70%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    fontWeight: "bold",
                    fontSize: "14px",
                    display: "flex",
                    textAlign: "center",
                    alignItems: "center",
                    padding: "5px",
                  }}
                >
                  جزئیات سفارش
                </p>
              </div>
              <div style={{ width: "15%", visibility: "hidden" }}>
                <p>hiiii</p>
              </div>
            </div>

            <div
              style={{ marginTop: "20px", flexDirection: "column" }}
              className="productsmain"
            >
              {context.orderDetailApi.length > 0 &&
                context.orderDetailApi.map((i, j) => (
                  <div
                    id={j}
                    style={{
                      background: selectedId.includes(j)
                        ? "#4caf50"
                        : undefined,
                    }}
                    onClick={() => selectfactor(j)}
                    className="minirows2"
                  >
                    <div className="headerOrderDetails">{i.productName}</div>

                    <div className="minirows3">
                      <div style={{ width: "30%" }}>
                        <img style={{ width: "100%" }} src={i.image} />
                      </div>

                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "14px",
                            margin: "5px",
                            justifyContent: "flex-start",
                            display: "flex",
                          }}
                        >{`قیمت واحد : ${i.custPrice} `}</p>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "14px",
                            margin: "5px",
                            justifyContent: "flex-start",
                            display: "flex",
                          }}
                        >{` مبلغ ناخالص : ${i.amount} `}</p>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "14px",
                            margin: "5px",
                            justifyContent: "flex-start",
                            display: "flex",
                          }}
                        >{` تخفیف : ${i.discount} `}</p>
                        <p
                          style={{
                            margin: "0",
                            fontSize: "14px",
                            margin: "5px",
                            justifyContent: "flex-start",
                            display: "flex",
                          }}
                        >{` مبلغ خالص : ${i.amountNut} `}</p>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )
      )}
      {pre === true ? (
        <button
          style={{ position: "fixed", bottom: "10px", height: "6vh" }}
          className="factorPlacefooter"
        >
          <Preloader2 />
        </button>
      ) : (
        <button
          style={{ position: "fixed", bottom: "10px", height: "6vh" }}
          className="factorPlacefooter"
          onClick={() => ShowFactor()}
        >
         {context.buttontitle}
        </button>
      )}
    </>
  );
};

export default SafareshatDetailsApi;
